import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

const STORAGE_KEY = "wit_cookie_consent";

export const CookieConsent = () => {
  const { t } = useTranslation();
  const reduced = usePreferStaticUI();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "accepted" && window.posthog?.opt_in_capturing) {
        window.posthog.opt_in_capturing();
        return;
      }
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (_) {}
    window.posthog?.opt_in_capturing?.();
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "essential");
    } catch (_) {}
    window.posthog?.opt_out_capturing?.();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <motion.div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
      className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-xl"
      initial={reduced ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
      data-testid="cookie-consent"
    >
      <div className="wit-glass-strong p-5 sm:p-6 shadow-lift border border-sandBeige/70">
        <p id="cookie-consent-title" className="text-sm font-medium text-ink mb-1">
          {t("cookie.title")}
        </p>
        <p id="cookie-consent-desc" className="text-sm text-warmGrey leading-relaxed mb-4">
          {t("cookie.message")}{" "}
          <Link to="/privacy" className="underline hover:text-raspberry">
            {t("footer.privacy")}
          </Link>
        </p>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={accept} className="wit-btn-primary text-sm px-5 py-2" data-testid="cookie-accept">
            {t("cookie.accept")}
          </button>
          <button type="button" onClick={decline} className="wit-btn-secondary text-sm px-5 py-2" data-testid="cookie-decline">
            {t("cookie.decline")}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default CookieConsent;
